module.exports = __webpack_public_path__ + "static/media/GWC24DigitalgaendaGoldenCircleHeader.bb0deb33.jpg";